import isEmpty from 'lodash/isEmpty';
import { listWM } from 'utils/Api';

import * as types from '../constants/ActionTypes';

function requestCertificate() {
  return {
    type: types.REQUEST_CERTIFICATE,
  };
}

function requestCertificateSuccess(certificateList) {
  return {
    type: types.REQUEST_CERTIFICATE_SUCCESS,
    certificateList,
    receivedAt: Date.now(),
  };
}

function requestCertificateFailure(error) {
  return {
    type: types.REQUEST_CERTIFICATE_FAILURE,
    error,
  };
}

export function fetchCertificate() {
  return (dispatch, getState) => {
    dispatch(requestCertificate());

    const { loginReducer: { user: { EmployeeMasterID, token } } } = getState();

    const fetchConfig = {
      entity: 'EmployeeMasterCertificate',
      headers: { Authorization: `Bearer ${token}` },
      params: {
        $filter: `Entity/EmployeeMasterID eq ${EmployeeMasterID}`,
      },
    };

    listWM(fetchConfig)
      .then(({ data }) => dispatch(requestCertificateSuccess(data)))
      .catch(error => dispatch(requestCertificateFailure(error)));
  };
}


export function fetchCertificateIfNeeded() {
  return (dispatch, getState) =>
    isEmpty(getState().certificateReducer.certificateData) &&
    dispatch(fetchCertificate());
}



// WEBPACK FOOTER //
// ./src/actions/certificate.js